import { EMPTY_STRING } from '../../../constants/common'
import { PAGINATION_ALL_ITEMS_VALUE } from '../../../constants/pagination'
import { getApi, postApi } from '../../../utils/api'
import { getPaginationApiParams } from '../../../utils/pagination'
import { EMAIL_CREATION_FORM_RECIPIENT_FIELD_EXPAND_API_PARAM } from '../EmailCreationForm'

export function getRecipients(data) {
  return postApi({
    data,
    endpoint: `api/profile/email-recipients`,
  })
}

export function getRecipientsWithExpandedEmails(ids) {
  return getRecipients({
    ...EMAIL_CREATION_FORM_RECIPIENT_FIELD_EXPAND_API_PARAM,
    ...getPaginationApiParams(PAGINATION_ALL_ITEMS_VALUE),
    filters: {
      id: ids,
    },
  })
}

export function getBuildings(search, apiParams) {
  const params = { ...(search ? { search } : null) }

  return getApi({
    endpoint: 'idwell-api/api/v3/construction/building-options/',
    params: {
      ...apiParams,
      ...params,
    },
  })
}

export function getFlats(apiParams) {
  const searchParams = new URLSearchParams([
    ...apiParams.building,
    ['page', apiParams.page],
    ['search', apiParams.search ?? EMPTY_STRING],
  ])

  return getApi({
    endpoint: 'idwell-api/api/v3/construction/flat-options/',
    params: searchParams,
  })
}

export function getFilteredRecipients(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/inhabitancy/email-recipients/',
  })
}
